<template>
    <div class="logout_pop">
       <div class="content">
            您确定要退出登录吗?
       </div> 
       <div class="btns">
        <el-button plain @click="closeModal">取消</el-button>
        <el-button type="primary" @click="onSuccess">确定</el-button>
       </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            
        }
    },
    methods: {
        closeModal() {
            this.$emit('closeModal')
        },
        onSuccess() {
            this.$emit('success')
        }
    },
}
</script>
<style lang="less" scoped>
    .logout_pop {
        .content {
            text-align: center;
            font-size: 1.5rem;
            margin: 3rem 0 4rem;
        }
        .btns {
            display: flex;
            justify-content: space-around;
            align-items: center;
            .el-button {
                width: 36%;
                height: 3.2rem;
                font-size: 1.2rem;
                padding: 0;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }
</style>